import React from 'react';
import PropTypes from 'prop-types';

function Overlay(props) {
  /**
   * Handles the case where the user clicks somewhere other than within the Store Pickup modal
   */
  const handleClickOff = (event) => {
    if (event.target.classList.contains('quickview-overlay')) {
      props.onClickOff();
    }
  };
  return (
    <div className="quickview-overlay open" onClick={handleClickOff} key="overlay-background" />
  );
}

Overlay.propTypes = {
  onClickOff: PropTypes.func.isRequired,
};
export default Overlay;
